import { HttpInterceptorFn } from '@angular/common/http';
import { inject, Injector } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { LocalStorageService } from '@core/providers/storage/local-storage.service';
import { throwError as observableThrowError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { PermissionsBackendService } from './core/providers/backend/permissions-backend.service';
import { RolesService } from './core/providers/backend/roles.service';
import { NavigationService } from './core/providers/navigation/navigation.service';
import { NotificationService } from './core/providers/notification/notification.service';
import { SessionExpiryService } from './core/providers/session/session-expiry.service';
import { UserService } from './core/providers/user/user.service';
import { CONSTANTS } from './shared/constants';

export const fbiInterceptorFn: HttpInterceptorFn = (request, next) => {
  const injector = inject(Injector);

  return next(request).pipe(
    catchError((error: { status: number }) => {
      if (
        error.status === CONSTANTS.REQUEST_ERRORS.HTTP_403 &&
        !injector.get(PermissionsBackendService).getIsRedirected()
      ) {
        const { TITLE, TEXT } = injector.get(TranslateService).instant('SHARED.WARNINGS.NO_ACCESS');

        injector.get(NotificationService).displaySwalPopupWithSpinner(TITLE, TEXT);
        const permissionsBackendService = injector.get(PermissionsBackendService);
        permissionsBackendService.setRedirectStatus(true);
        permissionsBackendService.invalidateAccountsCache();
        permissionsBackendService.invalidateVenuesCacheForAllAccounts();
        injector.get(NavigationService).goToNoAccess();
      } else if (
        error.status === CONSTANTS.REQUEST_ERRORS.HTTP_401 &&
        injector.get(SessionExpiryService).claimUnauthorizedHandling()
      ) {
        localStorage.removeItem(CONSTANTS.AUTH.ID_TOKEN);
        injector.get(LocalStorageService).clear();
        sessionStorage.clear();
        document.cookie = `auth0.ssodata =; Path=/; Expires=Thu, 01 Jan 1970 00:00:01 GMT;`;

        const permissionsBackendService = injector.get(PermissionsBackendService);
        permissionsBackendService.invalidateAccountsCache();
        permissionsBackendService.invalidateVenuesCacheForAllAccounts();
        injector.get(UserService).setAuthorizedData();
        injector.get(RolesService).clearRoles();

        injector
          .get(NotificationService)
          .warnWithKey('SHARED.NOTIFICATIONS.SESSION_EXPIRED', undefined, { duration: 6000 });
        injector.get(NavigationService).goToLogin();
      }

      return observableThrowError(error);
    })
  );
};
